import { IconBase } from './IconBase'

type IconCharacters5Props = React.ComponentProps<'svg'>

export const IconCharacters5 = ({ ...props }: IconCharacters5Props) => {
  return (
    <IconBase width="1em" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        d="M5.003 10.452c-.17-.066-.242-.111-.348-.168l-.284-.163a8.982 8.982 0 0 1-1.503-1.147C2.264 8.4 1.705 7.692 1.392 6.9a5.465 5.465 0 0 1-.391-2.319A5.508 5.508 0 0 1 1.507 2.5c.042.684.234 1.332.51 1.892a3.876 3.876 0 0 0 1.094 1.36c.412.33.877.524 1.392.663a5.46 5.46 0 0 0 1.178.182c.064.002.128.004.188.002.051-.003.138 0 .129-.022l-.995 3.875ZM17.991 6.578c-.009.022.078.019.129.022.06.002.123 0 .188-.002a5.398 5.398 0 0 0 1.177-.181c.515-.14.98-.335 1.393-.664a3.876 3.876 0 0 0 1.093-1.36 5.013 5.013 0 0 0 .511-1.893c.297.624.466 1.333.506 2.081a5.463 5.463 0 0 1-.392 2.319c-.312.791-.871 1.5-1.475 2.075a8.614 8.614 0 0 1-1.503 1.146l-.284.164c-.107.056-.179.101-.349.168l-.994-3.875Z"
        fill="#6D4C41"
      />
      <path
        d="M16.756 21H7.244a4 4 0 0 1-3.942-4.676S3.911 11.212 4 9.5c.204-3.995 4.17-7 7.823-7h.353c3.653 0 7.62 3.005 7.824 7 .087 1.713.698 6.824.698 6.824A4 4 0 0 1 16.756 21Z"
        fill="#7CB342"
      />
      <path d="M8.5 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" fill="#558B2F" />
      <path
        d="M8.75 11.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
        fill="#FFEA00"
      />
      <path
        d="M8.75 10.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
        fill="#000"
      />
      <path d="M15.5 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" fill="#558B2F" />
      <path
        d="M15.25 11.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
        fill="#FFEA00"
      />
      <path
        d="M18 17.5c0 2.242-2.687 0-6 0s-6 2.253-6 0c0-2 2.687-4 6-4s6 2 6 4Z"
        fill="#1B5E20"
      />
      <path
        d="M12 17.5c1.463 0 2.802.436 3.842.732a2.523 2.523 0 0 0-2.389-1.73c-.542 0-1.042.172-1.454.46a2.528 2.528 0 0 0-1.455-.46c-1.12 0-2.056.73-2.394 1.735 1.043-.296 2.384-.737 3.85-.737Z"
        fill="#FF3D00"
      />
      <path
        d="M15.25 10.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
        fill="#000"
      />
      <path
        d="M9.5 14.98v-1.084a7.014 7.014 0 0 0-1.431.653c.166.268.36.55.57.788.302.343.861.107.861-.357ZM15.361 15.337c.21-.238.402-.52.57-.789a7.015 7.015 0 0 0-1.431-.652v1.084c0 .463.559.7.861.357ZM7.063 16.933c-.086.425-.1.951.066 1.544.413-.052.921-.205 1.508-.375-.29-.38-.55-.947-.694-1.289-.198-.472-.776-.393-.88.12ZM16.936 16.933c-.104-.513-.681-.592-.88-.12-.143.342-.406.905-.695 1.285.586.169 1.09.32 1.508.375a3.274 3.274 0 0 0 .067-1.54Z"
        fill="#E0E0E0"
      />
      <path
        d="M8 20.005c.497-.537 1.162-.884 1.847-1.125a6.698 6.698 0 0 1 4.307-.001c.685.24 1.35.588 1.846 1.127a16.863 16.863 0 0 0-8-.001Z"
        fill="#558B2F"
      />
      <path
        d="M10.5 9.5a.998.998 0 0 1-.394-.081l-3.5-1.5a1 1 0 1 1 .788-1.838l3.5 1.5a1 1 0 0 1-.395 1.92ZM13.5 9.5a1 1 0 0 1-.393-1.919l3.5-1.5a1 1 0 1 1 .787 1.838l-3.5 1.5a.998.998 0 0 1-.393.081Z"
        fill="#1B5E20"
      />
      <path
        d="M10.25 5.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM13.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM5.5 13.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM8 13.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM5 16a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM17.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM19 15.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
        fill="#689F38"
      />
    </IconBase>
  )
}
